import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';

class Importacao extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const props = this.props;

        const app = props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.IMPORTACAO)
            return null;

        const importacao = props.importacao;

        if (!importacao.events)
            return (
                <div>
                    <h1 className="page-header">Importar planilha de participantes</h1>

                    <h2>Nenhum evento registrado.</h2>
                </div>
            );

        const token = props.token;

        const onUploadFile = (e) => {
            e.preventDefault();

            if (!this.file.files[0])
                return;

            props.events.onImportSheet(
                this.file.files[0],
                importacao.selectEvent,
                function () {
                    $(this.file).val('');
                }.bind(this),
                token);
        };

        const onChangeEvent = function (e) {
            e.preventDefault();
            props.events.onSelectEventForImportacao(e.target.value);
        };

        const tableFails = !importacao.fails ?
            null : (
                importacao.fails.length === 0 ?
                    <div>
                        <br />
                        <br />
                        <div className="bg-primary" style={{padding: "20px"}}>
                            <p>Todos os participantes foram cadastrados com sucesso</p>
                        </div>
                    </div>
                    :
                    <div>
                        <br />
                        <table className="table table-bordered table-condensed table-striped">
                            <caption>Erros de importação</caption>
                            <thead>
                                <tr>
                                    <th>Linha</th>
                                    <th>Error</th>
                                </tr>
                            </thead>
                            <tbody>
                            {importacao.fails.map(function (fail) {
                                return (
                                    <tr key={fail.line}>
                                        <td><small>{fail.line}</small></td>
                                        <td><small>{fail.error}</small></td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>
                    </div>
            );

        return (
            <div>
                <h1 className="page-header">Importar planilha de participantes</h1>

                <div>
                    <form encType="multipart/form-data" >
                        <div className="form-group">
                            <label>Evento:</label>
                            <select value={importacao.selectEvent ? importacao.selectEvent.id : ""}
                                    onChange={onChangeEvent}
                                    disabled={importacao.processing === true}
                                    className="form-control">
                                {importacao.events.map(function (event) {
                                    return <option key={event.id} value={event.id}>{event.name}</option>
                                })}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>Arquivo:</label>
                            <input ref={(ref) => { this.file = ref; }} type="file" name="file"
                                   disabled={importacao.processing === true} />
                            <p className="help-block">
                                Arquivo deve estar no formato CSV do Excel (separados por ponto e vírgula).
                            </p>
                            <p className="help-block">
                                As seguintes colunas devem estar presentes no arquivo CSV: nome, email,
                                cpf_cnpj, pacote, situacao e nucleo_origem. Não importa se estão em
                                maiúsculas ou minúsculas.
                            </p>
                            <p className="help-block">
                                O campo situação deve ter um dos seguintes valores números:
                            </p>
                            <ol className="help-block">
                                <li>Pagamento realizado</li>
                                <li>Aguardando pagamento</li>
                                <li>Cortesia/Gratuidade</li>
                            </ol>
                            <p className="help-block">
                                Certifique-se de converter o arquivo para UTF-8 antes de fazer o upload.
                            </p>
                        </div>

                        <input className="btn btn-primary"
                               disabled={importacao.processing === true}
                               type="button"
                               value={importacao.processing === true ? "Processando..." : "Enviar"}
                               onClick={onUploadFile} />
                    </form>
                </div>

                {tableFails}
            </div>
        );
    }
}

export default Importacao;


// WEBPACK FOOTER //
// src/views/pages/Importacao.jsx